import { Component, Vue } from 'vue-property-decorator';
import { africaOptions } from '../globals';

export class I18n {

    public static BASE_CATEGORY = 'cms';

    public static buildContext(subCategory: string[] | string | null = null): string {
        if (!subCategory) {
            return I18n.BASE_CATEGORY;
        }

        return [I18n.BASE_CATEGORY].concat(Array.isArray(subCategory) ? subCategory : [subCategory]).join(I18n.DELIMITER);
    }

    public static t(text: string, context: string[] | string | null = null): string {
        const category: string = I18n.buildContext(context);
        const translation = africaOptions.i18n.find((r) => r.message === text && r.category === category);

        return translation ? translation.translation : text;
    }

    private static DELIMITER = '/';
}

@Component
export class I18nMixin extends Vue {
    public t(text: string, context: string[] | string | null = null): string {
        return I18n.t(text, context);
    }
}
